export default "__VITE_ASSET__0t7HBVkF__";